import { Component } from "@angular/core";
import { LoginService } from "app/services/login/login.service";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-confirming',
  templateUrl: './confirming.component.html',
  styleUrls: ['./confirming.component.scss']
})
export class ConfirmingComponent  {

  constructor(private loginService:LoginService) { }


  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
